import React from 'react'
import UserServicePlanManagement from '../../../components/UserServicePlanManagement/UserServicePlanManagement';

const UserPurchasedServicePlan = () => {
    return (
        <UserServicePlanManagement />
    )
}

export default UserPurchasedServicePlan;
